import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-2006",
  "use": "icon-2006-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-2006\" viewBox=\"0 0 16 16\" id=\"icon-2006\">\n  <path d=\"M1 6.368a2.183 2.183 0 1 0 4.368 0c0-1.207-2.184-4.367-2.184-4.367S1 5.161 1 6.368zm4.816 5.449a2.183 2.183 0 1 0 4.368 0C10.184 10.61 8 7.449 8 7.449s-2.184 3.161-2.184 4.368zm7-9.816s-2.184 3.161-2.184 4.368A2.183 2.183 0 1 0 15 6.368c0-1.208-2.184-4.367-2.184-4.367z\" style=\"fill-rule:evenodd;clip-rule:evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol